"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;
var _react = require("react");
var _react2 = _interopRequireDefault(_react);
var _Icon2 = require("../../../Icon");
var _Icon3 = _interopRequireDefault(_Icon2);
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }
  return _typeof(obj);
}
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }
  return _assertThisInitialized(self);
}
function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self;
}
function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}
function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };
  return _setPrototypeOf(o, p);
}
var IconExpand6Alternate = /*#__PURE__*/
function (_Icon) {
  _inherits(IconExpand6Alternate, _Icon);
  function IconExpand6Alternate(props) {
    var _this;
    _classCallCheck(this, IconExpand6Alternate);
    _this = _possibleConstructorReturn(this, _getPrototypeOf(IconExpand6Alternate).call(this, props));
    _this.name = 'IconExpand6Alternate';
    _this.icon = _react2.default.createElement("svg", {
      viewBox: "0 0 24 24",
      width: "1em",
      height: "1em",
      focusable: "false",
      "aria-hidden": "true",
      role: "presentation"
    }, _react2.default.createElement("path", {
      className: "expand-6-alternate_svg__path0",
      d: "M11.25 7.242a1 1 0 00-1-1h-3.5a3 3 0 00-3 3v8a3 3 0 003 3h8a3 3 0 003-3v-2.5a1 1 0 00-2 0v2.5a1 1 0 01-1 1h-8a1 1 0 01-1-1v-8a1 1 0 011-1h3.5a1 1 0 001-1z"
    }), _react2.default.createElement("path", {
      className: "expand-6-alternate_svg__path1",
      d: "M9.75 15.742a1.5 1.5 0 001.06-.438l6.468-6.458a.249.249 0 01.353 0l1.769 1.765a.5.5 0 00.354.147.512.512 0 00.191-.038.5.5 0 00.309-.462v-6a.5.5 0 00-.5-.5h-6a.5.5 0 00-.354.853l1.761 1.76a.255.255 0 01.073.177.25.25 0 01-.074.177l-6.47 6.456a1.5 1.5 0 001.06 2.561z"
    }));
    return _this;
  }
  return IconExpand6Alternate;
}(_Icon3.default);
exports.default = IconExpand6Alternate;